(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["NPlayer"] = factory();
	else
		root["NPlayer"] = factory();
})(this, function() {
return 